import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { font } from '@/theme/zeelool.theme';
import { EPlatform } from '@/utils/enums/platform-enum';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { MinusOutlined, PlusOutlined } from '@zeelool/icon';
import { useTranslations } from '@/i18n/use-translations';
import React, { ReactNode, useContext, useState } from 'react';

// PC端的加减号图标
const PlusIcon = () => <PlusOutlined className="text-[16px]" style={{ color: '#282828' }} />;

const MinusIcon = () => <MinusOutlined className="text-[16px]" style={{ color: '#282828' }} />;

interface GoodsDetailCollapseProps {
  title: string;
  defaultOpen?: boolean;
  onChange?: () => void;
  children: ReactNode;
}

const GoodsDetailCollapse: React.FC<GoodsDetailCollapseProps> = ({
  title,
  defaultOpen = false,
  onChange,
  children,
}) => {
  const t = useTranslations('goodsDetail');
  const [expanded, setExpanded] = useState<boolean>(defaultOpen);
  const { deviceType } = useContext(ResponsiveContext);

  const handleChange = () => {
    setExpanded(!expanded);
    onChange?.();
  };

  const getExpandIcon = () => {
    return expanded ? <MinusIcon /> : <PlusIcon />;
  };

  return (
    <Box className="goods-detail-collapse border-t border-[#dce0e8]">
      <Accordion
        expanded={expanded}
        onChange={handleChange}
        disableGutters
        elevation={0}
        square
        sx={{
          backgroundColor: 'transparent',
          '&:before': {
            display: 'none',
          },
        }}
      >
        <AccordionSummary
          expandIcon={getExpandIcon()}
          aria-controls={t('collapse.ariaControls')}
          id={t('collapse.ariaHeader')}
          sx={{
            minHeight: deviceType === EPlatform.WEB ? '20px' : '50px',
            height: deviceType === EPlatform.WEB ? 'auto' : '50px',
            mt: deviceType === EPlatform.WEB ? 3 : 0,
            mb: deviceType === EPlatform.WEB ? 1.75 : 0,
            p: 0,
            '& .MuiAccordionSummary-content': {
              m: 0,
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              transform: 'none',
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: font.bb,
              fontSize: deviceType === EPlatform.WEB ? '16px' : '3.733vw',
              color: '#282828',
              lineHeight: '19px',
              textAlign: 'left',
              textTransform: 'none',
            }}
          >
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>{children}</AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default GoodsDetailCollapse;
